// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__yd3dq","item":"style_item__OEU5j","skolkovo":"style_skolkovo__Sge1V","sbrf":"style_sbrf__iNCfB","itemText":"style_item-text__Qg8jO"};